import React, { useState } from 'react';
import { NavBar, Card, Button, Space, Form, TextArea, Dialog, Toast } from 'antd-mobile';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/ApproveDetailPage.css';
import { approve } from '../componet/service';

const ApproveDetailPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { record } = location.state || {};
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    if (!record) {
        return (
            <div className="approve-detail-container">
                <NavBar back="返回" onBack={() => navigate(-1)}>
                    审批详情
                </NavBar>
                <div className="error-message">记录不存在或已被删除</div>
            </div>
        );
    }

    // 审批通过
    const handleApprove = async () => {
        try {
            await form.validateFields();
            const result = await Dialog.confirm({
                content: '确认审批通过该申请吗？',
            });

            if (result) {
                setLoading(true);
                const res = await approve(record.approveHisId, true, form.getFieldValue('approveDesc'));
                if (res.code === 0) {
                    Toast.show({
                        icon: 'success',
                        content: '审批通过成功',
                    });
                    navigate(-1);
                } else {
                    Toast.show({
                        icon: 'fail',
                        content: res.msg,
                    });
                }
            }
        } catch (error) {
            if (error.errorFields) {
                Toast.show({
                    icon: 'fail',
                    content: '请填写审批意见',
                });
            }
        } finally {
            setLoading(false);
        }
    };

    // 审批拒绝
    const handleReject = async () => {
        try {
            await form.validateFields();
            const result = await Dialog.confirm({
                content: '确认拒绝该申请吗？',
            });

            if (result) {
                setLoading(true);

                const res = await approve(record.approveHisId, false, form.getFieldValue('approveDesc'));
                if (res.code === 0) {
                    Toast.show({
                        icon: 'success',
                        content: '已拒绝申请',
                    });
                    navigate(-1);
                } else {
                    Toast.show({
                        icon: 'fail',
                        content: res.msg,
                    });
                }
            }
        } catch (error) {
            if (error.errorFields) {
                Toast.show({
                    icon: 'fail',
                    content: '请填写审批意见',
                });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="approve-detail-container">
            <NavBar back="返回" onBack={() => navigate(-1)}>
                审批详情
            </NavBar>

            <div className="detail-content">
                <Card className="detail-card">
                    <div className="detail-header">
                        <div className="device-title">{record.name}</div>
                        <div className="approve-type">{record.approveType}</div>
                    </div>

                    <div className="detail-info">
                        <div className="info-item">
                            <span className="info-label">资产编号</span>
                            <span className="info-value">{record.assetNo}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">设备类型</span>
                            <span className="info-value">{record.typeName}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">出借人</span>
                            <span className="info-value">{record.borrower}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">关系人</span>
                            <span className="info-value">{record.relatedUser}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">申请人</span>
                            <span className="info-value">{record.applyUser}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">申请时间</span>
                            <span className="info-value">{record.approveApplyTime}</span>
                        </div>

                        {record.approveType === '申请转移' && (
                            <>
                                <div className="info-item">
                                    <span className="info-label">目标转移人员</span>
                                    <span className="info-value">{record.targetBorrower}</span>
                                </div>
                                <div className="info-item">
                                    <span className="info-label">目标关系人</span>
                                    <span className="info-value">{record.targetRelatedUser}</span>
                                </div>
                                <div className="info-item">
                                    <span className="info-label">申请原因</span>
                                    <span className="info-value"></span>
                                </div>
                                <div className="info-item" style={{ paddingLeft: "5vw" }}>
                                    {record.reason}
                                </div>
                                {record.approveStatus !== '申请中' &&
                                    <>
                                        <div className="info-item">
                                            <span className="info-label">审批意见</span>
                                            <span className="info-value"></span>
                                        </div>
                                        <div className="info-item" style={{ paddingLeft: "5vw" }}>
                                            {record.approveDesc}
                                        </div>
                                    </>
                                }
                            </>
                        )}
                    </div>


                    {record.approveStatus === '申请中' &&
                        <>
                            <Form form={form} className="approve-form">
                                <Form.Item
                                    name="approveDesc"
                                    label="审批意见"
                                    // rules={[{ required: true, message: '请填写审批意见' }]}
                                >
                                    <TextArea
                                        placeholder="请输入审批意见"
                                        rows={4}
                                        maxLength={200}
                                        showCount
                                    />
                                </Form.Item>
                            </Form>
                            <div className="action-buttons">
                                <Space direction="vertical" block>
                                    <Button
                                        block
                                        color="primary"
                                        onClick={handleApprove}
                                        loading={loading}
                                    >
                                        审核通过
                                    </Button>
                                    <Button
                                        block
                                        color="danger"
                                        onClick={handleReject}
                                        loading={loading}
                                    >
                                        审核拒绝
                                    </Button>
                                </Space>
                            </div>
                        </>

                    }

                </Card>
            </div>
        </div>
    );
};

export default ApproveDetailPage;